import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";

function StdPreviousEducation() {
  const navigate = useNavigate();
  const [previousEducation, setPreviousEducation] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchPreviousEducation = async () => {
      const studentId = sessionStorage.getItem("userId");

      if (!studentId) {
        setError("Student session details are missing. Please log in again.");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError("");

        const response = await fetch(
          `${ApiUrl.apiurl}STUDENT_PROFILE/GetStudentPreviousEducation/${studentId}/`
        );

        const contentType = response.headers.get("content-type") || "";
        const payload = contentType.includes("application/json")
          ? await response.json()
          : null;

        if (!response.ok || !payload || payload.message !== "Success") {
          throw new Error(
            payload?.message || "Unable to load previous education details."
          );
        }

        setPreviousEducation(Array.isArray(payload.data) ? payload.data : []);
      } catch (fetchError) {
        console.error("Error fetching previous education:", fetchError);
        setPreviousEducation([]);
        setError(
          fetchError.message || "Unable to load previous education details."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchPreviousEducation();
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                PREVIOUS EDUCATION DETAILS
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                    onClick={() => navigate("/student/dashboards")}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="col-12 container-fluid mt-4">
                {loading ? (
                  <div className="text-center py-4">
                    Loading previous education details...
                  </div>
                ) : error ? (
                  <div className="alert alert-danger mb-0">{error}</div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Sr No</th>
                          <th>Name of School</th>
                          <th>Location</th>
                          <th>Class Completed</th>
                          <th>Years Attended From</th>
                          <th>Years Attended To</th>
                          <th>Language Instruction</th>
                          <th>Transfer Certificate Provided</th>
                          <th>Result</th>
                        </tr>
                      </thead>
                      <tbody>
                        {previousEducation.length > 0 ? (
                          previousEducation.map((row, index) => (
                            <tr key={row.id || index}>
                              <td>{index + 1}</td>
                              <td>{row.nameofschool || "-"}</td>
                              <td>{row.location || "-"}</td>
                              <td>{row.class_completed || "-"}</td>
                              <td>{row.year_from || "-"}</td>
                              <td>{row.year_to || "-"}</td>
                              <td>{row.language_of_instruction || "-"}</td>
                              <td>{row.transfer_certificate || "-"}</td>
                              <td>{row.result || "-"}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9" className="text-center">
                              No previous education details available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StdPreviousEducation;
